import { useState } from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslationApp } from "../../lib/i18next";
import Button from "./Button";
import IconButton from "@mui/material/IconButton";
import Loader from "../Loaders/Loader";
import Tooltip from "@mui/material/Tooltip";

const ButtonMenu = ({
  showLabel = true,
  loading = false,
  disabled = false,
  options,
  textButton = "",
  colorButton = "primary",
  fullWidth = false,
  sx = {},
  sxMenu = {},
  mode = "button",
  iconButton = null,
  endIcon = null,
  tooltipText,
  edge = "end",
  anchorOrigin = null,
  transformOrigin = null,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const onSelectMenu = (event) => {
    event?.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const onCloseMenu = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const { t } = useTranslationApp();

  return (
    <>
      {mode === "icon" && (
        <>
          {loading ? (
            <Loader size={20} />
          ) : (
            <Tooltip title={tooltipText}>
              <IconButton
                onClick={onSelectMenu}
                sx={sx}
                edge={edge}
                disabled={disabled}
              >
                {iconButton}
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
      {mode === "button" ? (
        <Button
          loading={loading}
          disabled={disabled}
          fullWidth={fullWidth}
          color={colorButton}
          onClick={onSelectMenu}
          sx={sx}
        >
          {iconButton && iconButton}
          {showLabel && t(textButton)}
          {endIcon && endIcon}
        </Button>
      ) : null}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onCloseMenu}
        {...(anchorOrigin && { anchorOrigin })}
        {...(transformOrigin && { transformOrigin })}
        sx={{ ...sxMenu }}
        MenuListProps={{
          onClick: (e) => e?.stopPropagation?.(),
          onMouseDown: (e) => e?.stopPropagation?.(),
        }}
        PaperProps={{
          style: {
            maxHeight: 48 * 5 + 8,
            overflow: "auto",
          },
        }}
      >
        {options.map((option, index) => {
          if (option.customComponent)
            return <Box key={index}>{option.customComponent}</Box>;
          return (
            <MenuItem
              key={option.label}
              disabled={Boolean(option.disabled)}
              onClick={(e) => {
                e?.stopPropagation();
                if (option.disabled) return;
                option.onClick();
                setAnchorEl(null);
              }}
            >
              {option.icon ? option.icon : null}{" "}
              {showLabel && t(option.label, option.extrapolation)}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ButtonMenu;
